const popularBuilds = function(root, stats, buildNames) { // takes in root for engraving names
    return [
        {
            build_name: buildNames.Mayhem_Berserker,
            build_engravings: [root.Mayhem, root.Masters_Tenacity, root.Keen_Blunt_Weapon, root.Raid_Captain, root.Master_of_Ambush, root.Grudge, root.Increases_Mass, root.Cursed_Doll],
            primary_stat: stats.Crit,
            secondary_stat: stats.Swiftness
        },
        {
            build_name: buildNames.Technique_Berserker,
            build_engravings: [root.Berserkers_Technique, root.Keen_Blunt_Weapon, root.Awakening, root.Spirit_Absorption, root.Raid_Captain, root.Super_Charge, root.Master_of_Ambush, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Blue_Warlord_Gunlancer,
            build_engravings: [root.Combat_Readiness, root.Barricade, root.Stabilized_Status, root.Hit_Master, root.Spirit_Absorption, root.Adrenaline, root.Awakening, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Red_Warlord_Gunlancer,
            build_engravings: [root.Lone_Knight, root.Super_Charge, root.Master_Brawler, root.Keen_Blunt_Weapon, root.Adrenaline, root.Precise_Dagger, root.Combat_Readiness, root.Spirit_Absorption, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Crit,
            secondary_stat: stats.Swiftness
        },
        {
            build_name: buildNames.Blessing_Paladin,
            build_engravings: [root.Blessed_Aura, root.Awakening, root.Expert, root.Drops_of_Ether, root.Vital_Point_Hit, root.Judgment, root.Spirit_Absorption, root.Heavy_Armor, root.Explosive_Expert],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Swiftness
        },
        {
            build_name: buildNames.Deathblow_Striker,
            build_engravings: [root.Deathblow, root.Master_of_Ambush, root.Keen_Blunt_Weapon, root.Spirit_Absorption, root.Adrenaline, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Esoteric_Flurry_Striker,
            build_engravings: [root.Esoteric_Flurry, root.Master_of_Ambush, root.Keen_Blunt_Weapon, root.Adrenaline, root.Raid_Captain, root.Cursed_Doll, root.Increases_Mass, root.Grudge],
            primary_stat: stats.Swiftness,
            secondary_stat: `${stats.Crit} | ${stats.Specialization}`
        },
        {
            build_name: buildNames.Robust_Spirit_Soulfist,
            build_engravings: [root.Robust_Spirit, root.Precise_Dagger, root.Adrenaline, root.Awakening, root.Grudge, root.Cursed_Doll, root.Increases_Mass],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Energy_Overflow_Soulfist,
            build_engravings: [root.Energy_Overflow, root.Adrenaline, root.Raid_Captain, root.Keen_Blunt_Weapon, root.Increases_Mass, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Taijutsu_Scrapper,
            build_engravings: [root.Ultimate_Skill_Taijutsu, root.Adrenaline, root.Master_of_Ambush, root.Grudge, root.Cursed_Doll, root.Keen_Blunt_Weapon],
            primary_stat: stats.Crit,
            secondary_stat: stats.Swiftness
        },
        {
            build_name: buildNames.Shock_Training_Scrapper,
            build_engravings: [root.Shock_Training, root.Adrenaline, root.Master_of_Ambush, root.Spirit_Absorption, root.Grudge, root.Cursed_Doll, root.Keen_Blunt_Weapon],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Esoteric_Wardancer,
            build_engravings: [root.Esoteric_Skill_Enhancement, root.Raid_Captain, root.Keen_Blunt_Weapon, root.Adrenaline, root.Master_of_Ambush, root.Awakening, root.Lightning_Fury, root.Grudge, root.Cursed_Doll, root.Increases_Mass],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Specialization
        },
        {
            build_name: buildNames.First_Intention_Wardancer,
            build_engravings: [root.First_Intention, root.Raid_Captain, root.Keen_Blunt_Weapon, root.Master_of_Ambush, root.Awakening, root.Lightning_Fury, root.Grudge, root.Cursed_Doll, root.Increases_Mass],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Enhanced_Weapon_Deadeye,
            build_engravings: [root.Enhanced_Weapon, root.Master_of_Ambush, root.Adrenaline, root.Spirit_Absorption, root.Keen_Blunt_Weapon, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: `${stats.Swiftness} | ${stats.Crit}`
        },
        {
            build_name: buildNames.Pistoleer_Deadeye,
            build_engravings: [root.Pistoleer, root.Adrenaline, root.Precise_Dagger, root.Keen_Blunt_Weapon, root.Raid_Captain, root.Master_of_Ambush, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: `${stats.Swiftness} | ${stats.Crit}`
        },
        {
            build_name: buildNames.Death_Strike_Sharpshooter,
            build_engravings: [root.Death_Strike, root.Hit_Master, root.Keen_Blunt_Weapon, root.Grudge, root.Cursed_Doll, root.Adrenaline],
            primary_stat: `${stats.Crit} | ${stats.Swiftness}`,
            secondary_stat: stats.Specialization
        },
        {
            build_name: buildNames.Loyal_Companion_Sharpshooter,
            build_engravings: [root.Loyal_Companion, root.Raid_Captain, root.Keen_Blunt_Weapon, root.Hit_Master, root.Grudge, root.Cursed_Doll, root.Awakening,],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Death_Strike_Companion_Sharpshooter,
            build_engravings: [root.Death_Strike, root.Loyal_Companion, root.Hit_Master, root.Keen_Blunt_Weapon, root.Raid_Captain, root.Awakening, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Crit,
            secondary_stat: stats.Specialization
        },
        {
            build_name: buildNames.Firepower_Enhancement_Artillerist,
            build_engravings: [root.Firepower_Enhancement, root.Hit_Master, root.Adrenaline, root.Raid_Captain, root.Keen_Blunt_Weapon, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Barrage_Enhancement_Artillerist,
            build_engravings: [root.Barrage_Enhancement, root.All_Out_Attack, root.Adrenaline, root.Keen_Blunt_Weapon, root.Hit_Master, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: `${stats.Crit} | ${stats.Swiftness}`
        },
        {
            build_name: buildNames.Peacemaker_Gunslinger,
            build_engravings: [root.Peacemaker, root.Hit_Master, root.Adrenaline, root.Keen_Blunt_Weapon, root.Raid_Captain, root.Spirit_Absorption, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Crit,
            secondary_stat: `${stats.Specialization} | ${stats.Swiftness}`
        },
        {
            build_name: buildNames.Time_To_Hunt_Gunslinger,
            build_engravings: [root.Time_To_Hunt, root.Peacemaker, root.Keen_Blunt_Weapon, root.Hit_Master, root.Adrenaline, root.Raid_Captain, root.Cursed_Doll, root.Grudge],
            primary_stat: `${stats.Specialization} | ${stats.Swiftness}`,
            secondary_stat: `${stats.Crit} | ${stats.Specialization}`
        },
        {
            build_name: buildNames.Remaining_Energy_Deathblade,
            build_engravings: [root.Remaining_Energy, root.Super_Charge, root.Master_of_Ambush, root.Adrenaline, root.Keen_Blunt_Weapon, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Surge_Deathblade,
            build_engravings: [root.Surge, root.Master_of_Ambush, root.Adrenaline, root.Sight_Focus, root.Super_Charge, root.Keen_Blunt_Weapon, root.Cursed_Doll, root.Grudge],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Perfect_Suppression_Shadowhunter,
            build_engravings: [root.Perfect_Suppression, root.Master_of_Ambush, root.Keen_Blunt_Weapon, root.Adrenaline, root.Spirit_Absorption, root.Raid_Captain, root.Precise_Dagger, root.Cursed_Doll, root.Grudge],
            primary_stat: stats.Crit,
            secondary_stat: stats.Swiftness
        },
        {
            build_name: buildNames.Demonic_Impulse_Shadowhunter,
            build_engravings: [root.Demonic_Impulse, root.Adrenaline, root.Hit_Master, root.Keen_Blunt_Weapon, root.Spirit_Absorption, root.Raid_Captain, root.Cursed_Doll, root.Grudge],
            primary_stat: stats.Specialization,
            secondary_stat: `${stats.Crit} | ${stats.Swiftness}`
        },
        {
            build_name: buildNames.Desperate_Salvation_Bard,
            build_engravings: [root.Awakening, root.Desperate_Salvation, root.Heavy_Armor, root.Expert, root.Spirit_Absorption, root.Max_MP_Increase, root.Vital_Point_Hit, root.Drops_of_Ether],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Specialization
        },
        {
            build_name: buildNames.Igniter_Sorceress,
            build_engravings: [root.Igniter, root.All_Out_Attack, root.Hit_Master, root.Precise_Dagger, root.Grudge, root.Cursed_Doll, root.Adrenaline],
            primary_stat: stats.Specialization,
            secondary_stat: `${stats.Crit} | ${stats.Swiftness}`
        },
        {
            build_name: buildNames.Reflux_Sorceress,
            build_engravings: [root.Reflux, root.Precise_Dagger, root.Hit_Master, root.Adrenaline, root.All_Out_Attack, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Crit,
            secondary_stat: stats.Swiftness
        },
        {
            build_name: buildNames.Pinnacle_Glavier,
            build_engravings: [root.Pinnacle, root.Master_of_Ambush, root.Keen_Blunt_Weapon, root.Raid_Captain, root.All_Out_Attack, root.Grudge, root.Cursed_Doll, root.Increases_Mass],
            primary_stat: stats.Specialization,
            secondary_stat: `${stats.Swiftness} | ${stats.Crit}`
        },
        {
            build_name: buildNames.Control_Glavier,
            build_engravings: [root.Control, root.Master_of_Ambush, root.Adrenaline, root.Raid_Captain, root.Keen_Blunt_Weapon, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Hammer_Of_Rage_Destroyer,
            build_engravings: [root.Rage_Hammer, root.Super_Charge, root.Master_Brawler, root.Keen_Blunt_Weapon, root.Barricade, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Crit,
            secondary_stat: `${stats.Swiftness} | ${stats.Specialization}`
        },
        {
            build_name: buildNames.Gravity_Training_Destroyer,
            build_engravings: [root.Gravity_Training, root.Barricade, root.Master_Brawler, root.Spirit_Absorption, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Empress_Grace_Arcanist,
            build_engravings: [root.Empress_Grace, root.Barricade, root.Adrenaline, root.Hit_Master, root.Raid_Captain, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Order_Of_The_Emperor_Arcanist,
            build_engravings: [root.Order_Of_The_Emperor, root.Raid_Captain, root.Adrenaline, root.Increases_Mass, root.Hit_Master, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Jiudau_Arcanist,
            build_engravings: [root.Empress_Grace, root.Order_Of_The_Emperor, root.Adrenaline, root.Raid_Captain, root.Keen_Blunt_Weapon, root.Cursed_Doll, root.Grudge],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Arthetinean_Mechanist,
            build_engravings: [root.Arthetinean_Skill, root.Adrenaline, root.Keen_Blunt_Weapon, root.Raid_Captain, root.Awakening, root.Grudge, root.Increases_Mass, root.Increases_Mass],
            primary_stat: stats.Crit,
            secondary_stat: stats.Swiftness
        },
        {
            build_name: buildNames.Evolutionary_Legacy_Mechanist,
            build_engravings: [root.Evolutionary_Legacy, root.Adrenaline, root.Barricade, root.Raid_Captain, root.Keen_Blunt_Weapon, root.Stabilized_Status, root.Hit_Master, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: stats.Crit
        },
        {
            build_name: buildNames.Moon_Reaper,
            build_engravings: [root.Sound_Of_The_Moon, root.Master_of_Ambush, root.Keen_Blunt_Weapon, root.Adrenaline, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Specialization,
            secondary_stat: `${stats.Crit} | ${stats.Swiftness}`
        },
        {
            build_name: buildNames.Blood_Reaper,
            build_engravings: [root.Thirst, root.Master_of_Ambush, root.Adrenaline, root.Raid_Captain, root.Grudge, root.Cursed_Doll],
            primary_stat: stats.Swiftness,
            secondary_stat: stats.Specialization
        }
    ]
}
export default popularBuilds;